export const REFUND_STATE_COLOR_DICTIONARY: Record<string, string> = {
  "1": "primary", // Created
  "2": "orange", // PendingBlockage
  "3": "orange", // PreparedToProcess
  "4": "orange", // ProcessingRefund
  "5": "red", // RefundFailed
  "6": "green", // RefundSucceeded
  "-1": "red", // Cancelled
};

export const WAGE_PAYER_DICTIONARY: Record<number, string> = {
  1: "Payer",
  2: "Business",
};
